export const JIKEYIXIA = {
  name: { en: 'JikeDrop', zh: '即刻一下' },
  version: '0.2.9',
  path: '/jikeyixia',
  privacyPath: '/jikeyixia/privacy',
  productUrl: 'https://peacetech.app/jikeyixia',
  privacyUrl: 'https://peacetech.app/jikeyixia/privacy',
  downloadUrl: '/downloads/jikeyixia-0.2.9.zip',
  chromeStoreUrl: 'https://chromewebstore.google.com/detail/%E5%8D%B3%E5%88%BB%E4%B8%80%E4%B8%8B-%C2%B7-x-%E8%BD%AC%E5%8D%B3%E5%88%BB/hkbcoamldechmamejdeohbpkpmoebcmi',
  supportEmail: 'feedback@peacetech.app',
};
